export default __webpack_public_path__ + "static/media/bildefil_hvit.81f9b354.svg";